import { useState, useEffect } from "react";
import axios from "axios";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../CustomSelect";
// import resetImg from "../../../../picture/timer-language.png";
import resetImg from "../../../../../picture/timer-language.png";

const istekDokumentaAll = [
  { id: "sve", name: "SVI DOKUMENTI" },
  { id: "1", name: "ISTEKLI DOKUMENTI" },
  { id: "2", name: "ISTIČU USKORO (ALARM)" },
  { id: "3", name: "VAŽEĆI DOKUMENTI" },
];

const defaultPretraga = {
  vrsta: { id: "sve", name: "SVE" },
  istekDokumenta: { id: "sve", name: "SVI DOKUMENTI" },
  poslovnaJedinica: { id: "sve", name: "SVE" },
  pretraga: "",
};

function PretragaKolektivneOpreme({ onClose }) {
  const {
    sredstvaOpremaPretraga,
    setSredstvaOpremaPretraga,
    dictionary,
    baseUrl,
  } = useGlobalContext();

  const [pretraga, setPretraga] = useState(
    sredstvaOpremaPretraga || defaultPretraga,
  );
  const [vrsteIzBaze, setVrsteIzBaze] = useState([]);
  const [poslovneIzBaze, setPoslovneIzBaze] = useState([]);

  const normalize = (obj) => JSON.stringify(obj ?? defaultPretraga);

  const [isDirty, setIsDirty] = useState(false);

  // kad se otvori filter ili kad se promeni context pretraga, resetuj formu i dirty=false
  useEffect(() => {
    setPretraga(sredstvaOpremaPretraga || defaultPretraga);
    setIsDirty(false);
  }, [sredstvaOpremaPretraga]);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const { data } = await axios.get(
          `${baseUrl}/machines/get_search_filters.php`,
        );
        console.log("Filters loaded:", data);
        setVrsteIzBaze(data.vrste || []);
        setPoslovneIzBaze(data.poslovne || []);
      } catch (err) {
        console.error("Greška pri učitavanju filtera:", err);
      }
    };
    fetchFilters();
  }, [baseUrl]);

  const onSelectChangeVrsta = (newValue) => {
    setPretraga((prev) => ({ ...prev, vrsta: newValue }));
    setIsDirty(true);
  };
  const onSelectChangeIstekDokumenta = (newValue) => {
    setPretraga((prev) => ({ ...prev, istekDokumenta: newValue }));
    setIsDirty(true);
  };
  const onSelectChangePoslovnaJedinica = (newValue) => {
    setPretraga((prev) => ({ ...prev, poslovnaJedinica: newValue }));
    setIsDirty(true);
  };
  const onChangePretraga = (e) => {
    const { value } = e.target;
    setPretraga((prev) => ({ ...prev, pretraga: value }));
    setIsDirty(true);
  };

  const handlePretraga = () => {
    setSredstvaOpremaPretraga(pretraga);
    setIsDirty(false); // posle primene opet ZATVORI
  };

  const handleReset = () => {
    setPretraga(defaultPretraga);
    setSredstvaOpremaPretraga(null);
    setIsDirty(false); // posle refresha opet ZATVORI
  };

  return (
    <div style={{ padding: "10px"}}>
      <CustomSelect
        label={dictionary["vrstaSiO"]}
        allValues={vrsteIzBaze}
        selectedValue={pretraga.vrsta}
        onSelectChange={onSelectChangeVrsta}
      />
      <div style={{ margin: "5px 0" }}></div>
      <CustomSelect
        label={dictionary["poslovnaJedinica"]}
        allValues={poslovneIzBaze}
        selectedValue={pretraga.poslovnaJedinica}
        onSelectChange={onSelectChangePoslovnaJedinica}
      />
      <div style={{ margin: "5px 0" }}></div>
      <CustomSelect
        label={dictionary["istekDokumenta"]}
        allValues={istekDokumentaAll}
        selectedValue={pretraga.istekDokumenta}
        onSelectChange={onSelectChangeIstekDokumenta}
      />
      <div style={{ margin: "5px 0" }}></div>
      <input
        value={pretraga.pretraga}
        onChange={onChangePretraga}
        placeholder={`${dictionary["pretraga"]}...`}
        style={{
          width: "100%",
          fontSize: "16px",
          height: "40px",
          padding: "10px",
        }}
      />

      <div
        style={{
          display: "flex",
          gap: "10px",
          marginTop: "20px",
        }}
      >
        <div
          onClick={() => {
            if (isDirty) handlePretraga();
            else onClose?.(); // ZATVORI
          }}
          style={{ flex: 8 }}
        >
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            {isDirty
              ? dictionary["pretrazi"]
              : dictionary["zatvori"] || "ZATVORI"}
          </Button>
        </div>

        <div onClick={handleReset} style={{ flex: 2 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            {/* ovo ti je REFREŠ */}
            <img src={resetImg} alt="Reset" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PretragaKolektivneOpreme;
